import DropdownSelector from './DropdownSelector';

// single or multi-select dropdown selector
export class ManagerDropdownSelector extends DropdownSelector {
  constructor(props) {
    super(props);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.apiParams.company_branch_id !==
      this.props.apiParams.company_branch_id
    ) {
      // 支店が変更された場合にはパラメータを変更して
      // 内部が変更されるようにする。
      const apiParams = { ...this.props.apiParams };
      this.setState({ apiParams, loaded: false, options: [] });
      return;
    }

    if (this.state.opened) {
      // ドロップダウンが可視状態になった場合は、documentにコンポーネント外をclickしたかのイベントを追加する
      document.addEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
    if (!this.state.opened) {
      // ドロップダウンが不可視状態になった場合は、documentのclickイベントを削除する
      document.removeEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }

    if (this.state.api) {
      this.loadData();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/dropdowns/ManagerDropdownSelector.jsx